import { findSearchItemPath } from '@aibees/elephant/components/search-list-item-name/utils';
import {
  useSearchModeFromRoute,
  useSearchRouteInfo,
} from '@aibees/elephant/hooks';
import { useBootstrapApi } from '@aibees/elephant/hooks/bootstrap/use-bootstrap-api';
import { SearchMode, SearchType } from '@aibees/elephant/types';
import { useCallback, useMemo } from 'react';

export function useEntitySearchData() {
  const mode = useSearchModeFromRoute();
  const { type, presetType } = useSearchRouteInfo();
  const { data, isFetching } = useBootstrapApi();

  const getDescription = useCallback((): string => {
    switch (mode) {
      case SearchMode.Semantic:
        return 'Find your Companies via Text!';
      case SearchMode.Similarity:
        return 'Find your Lookalike Companies Here!';
      default:
        return type === SearchType.People
          ? 'Find all your B2B Contacts here!'
          : 'Find all your B2B Companies here!';
    }
  }, [mode, type]);

  const getRecords = (category: 'person' | 'company') => ({
    total: data?.[category]?.count.total ?? 0,
    unsaved: data?.[category]?.count.unsaved ?? 0,
    saved: data?.[category]?.count.saved ?? 0,
  });

  const { total, unsaved, saved } = useMemo(() => {
    return type === SearchType.People
      ? getRecords('person')
      : getRecords('company');
  }, [data, type]);

  const path = useMemo(
    () => `${findSearchItemPath(presetType)}?modality=SAVED`,
    [presetType]
  );

  return {
    description: getDescription(),
    totalRecordsValue: total,
    netNewRecordsValue: unsaved,
    savedRecordsValue: saved,
    isFetching,
    path,
    type,
  };
}
